import React from 'react';
import { useQuery } from 'react-query';
import Loading from '../../Shared/Loading';
import Service from './Service';

const Services = () => {

    const { data: allservices, isLoading } = useQuery('myservices', () =>
        fetch(`https://stark-wildwood-35883.herokuapp.com/myservices`)
            .then(res => res.json())
    );


    if (isLoading) {
        return <Loading />
    }


    return (
        <div className='py-5 lg:pb-10' id='services'>
            <div className='mb-10'
                data-aos="fade-down"
            >
                <h3 className='text-center text-2xl uppercase font-semibold text-green-500'>Services</h3>
                <h3 className='text-center text-3xl uppercase font-semibold py-2'>What I Do</h3>
            </div>

            <div className='grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-5'>
                {
                    allservices.map(service => <Service key={service._id} service={service} ></Service>)
                }
            </div>

        </div>
    );
};

export default Services;